enum SourceType {
  Video = 'video',
  Image = 'image',
}

export default SourceType;
